/** @typedef {{ agentOverrideType: string|null, agentOverrideValue: number|null }} OrgTourQuoteOverride */

/**
 * חישוב מחיר ההצעה ללקוח בלבד — לא דורס את שכבת המחיר ה-SSOT בטיול.
 * baselineCheckoutIls: מחיר הבסיס להצעה (חבילה אחרי HR, ובטיול מאורגן גם דמי טיפול).
 * הפונקציה לא מוסיפה עמלת אשראי.
 *
 * סוגים:
 * - none | null — ללא התאמת אדמין
 * - percent_on_checkout_ils — באחוזים על בסיס checkout
 * - fixed_add_checkout_ils — תוספת בש״ח
 * - manual_final_ils — מחיר סופי בש״ח
 *
 * @param {{ selectedResult?: object|null, baselineCheckoutIls?: number|null, override?: OrgTourQuoteOverride|null }} opts
 */
export function computeOrganizedTourAgentQuoteCommission(opts = {}) {
  const { selectedResult, baselineCheckoutIls, override } = opts;
  const otf = selectedResult?.ourPrice?.ourTotalFare ?? {};
  const basePrice = Number(otf.priceWithCommission);
  const originalHrCommission = Number(
    otf.hrCommission ?? otf.unifiedHrMargin ?? otf.embeddedHrMargin ?? 0
  );
  const checkout = Number(baselineCheckoutIls);

  let agentOverrideType = "none";
  let agentOverrideValue = null;
  let finalQuotePrice = checkout;

  if (
    override &&
    override.agentOverrideType &&
    override.agentOverrideType !== "none"
  ) {
    agentOverrideType = String(override.agentOverrideType);
    agentOverrideValue = Number(override.agentOverrideValue);
    if (
      agentOverrideType === "percent_on_checkout_ils" &&
      Number.isFinite(agentOverrideValue) &&
      Number.isFinite(checkout)
    ) {
      finalQuotePrice = Math.round(checkout * (1 + agentOverrideValue / 100));
    } else if (
      agentOverrideType === "fixed_add_checkout_ils" &&
      Number.isFinite(agentOverrideValue) &&
      Number.isFinite(checkout)
    ) {
      finalQuotePrice = Math.round(checkout + agentOverrideValue);
    } else if (
      agentOverrideType === "manual_final_ils" &&
      Number.isFinite(agentOverrideValue)
    ) {
      finalQuotePrice = Math.round(agentOverrideValue);
    }
  }

  if (!Number.isFinite(finalQuotePrice) || finalQuotePrice < 0) {
    finalQuotePrice =
      Number.isFinite(checkout) && checkout >= 0 ? checkout : NaN;
  }

  if (import.meta.env?.DEV && typeof console !== "undefined") {
    console.log("[ORG_TOUR_AGENT_QUOTE_COMMISSION_TRACE]", {
      basePrice,
      originalHrCommission,
      agentOverrideType,
      agentOverrideValue,
      baselineCheckoutIls: checkout,
      finalQuotePrice,
    });
  }

  return {
    basePrice,
    originalHrCommission,
    agentOverrideType,
    agentOverrideValue,
    baselineCheckoutIls: checkout,
    finalQuotePrice,
  };
}
